import script from "./SubmissionGuidelines.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionGuidelines.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionGuidelines.vue?vue&type=style&index=0&id=36baa5c4&scoped=true&lang=css"

import exportComponent from "/Users/davecalleja/work/convergence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36baa5c4"]])

export default __exports__